module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "xntk",
    staticStyle: {
      "background": "#fff"
    }
  }, [_c('img', {
    attrs: {
      "src": 'http://front.wh.jinxin-fertility.com/liveTelecastImg/' + _vm.num
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-530cfeb6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/project/articleProject/xntk2.vue
// module id = nQno
// module chunks = 6